module.exports = __webpack_public_path__ + "img/duct_simple_3way.47682002.svg";